module.exports = __webpack_public_path__ + "static/media/Homedelivery.8e7162d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Homedelivery.jpg
// module id = 38
// module chunks = 1